import { Box } from '@chakra-ui/react'
import {
  ILocalAudioTrack,
  IRemoteAudioTrack,
  useVolumeLevel,
} from 'agora-rtc-react'

type Props = {
  audioTrack: IRemoteAudioTrack | ILocalAudioTrack | undefined | null
  enabled: boolean
}

export const SpeakerIndicator: React.FC<Props> = ({ audioTrack, enabled }) => {
  if (!audioTrack || !enabled) {
    return <Component isSpeaking={false} />
  }
  return <WithTrackComponent audioTrack={audioTrack} />
}

const WithTrackComponent: React.FC<{
  audioTrack: IRemoteAudioTrack | ILocalAudioTrack // not null
}> = ({ audioTrack }) => {
  const volumeLevel = useVolumeLevel(audioTrack)
  const isSpeaking = volumeLevel > 0.5
  return <Component isSpeaking={isSpeaking} />
}

const Component: React.FC<{ isSpeaking: boolean }> = ({ isSpeaking }) => {
  return (
    <Box
      pos="absolute"
      zIndex="1"
      left="0"
      top="0"
      w="full"
      h="full"
      border="4px"
      borderColor={isSpeaking ? 'blue.500' : 'transparent'}
    />
  )
}
